module.exports = __webpack_public_path__ + "static/img/quyibufang.f5f0ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quyibufang.png
// module id = wPwo
// module chunks = 1